import script from "./GamesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GamesCard.vue?vue&type=script&setup=true&lang=js"

import "./GamesCard.vue?vue&type=style&index=0&id=55a370b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55a370b4"]])

export default __exports__